import { Chip, Tooltip } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';

interface CachedResultBadgeProps {
  /** When true, the result was served from the saved computation cache (no recompute). */
  cached: boolean;
}

/**
 * Discreet indicator shown next to a results view when the backend served a
 * previously saved computation instead of recomputing it. Renders nothing when
 * the result was freshly computed.
 */
export function CachedResultBadge({ cached }: CachedResultBadgeProps) {
  if (!cached) return null;

  return (
    <Tooltip title="These results were loaded instantly from a previous computation. Change a project parameter to recompute.">
      <Chip icon={<BoltIcon />} label="Saved result" color="success" variant="outlined" size="small" />
    </Tooltip>
  );
}

export default CachedResultBadge;
